import styled from "styled-components";
import { grayColor } from "~/components/layout/Variables";

export const ContainerBody = styled.div`
  padding: 0rem 6rem;

  @media(max-width: 770px) {
    padding: 0rem;
  }
`;

export const AreaTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  img {
    width: 10%;
  }
`;

export const HeaderMessage = styled.p`
  font-weight: bold;
  text-align: center;
  color: #707070;
  margin: 1rem 0rem 1rem 0rem;
`;

export const DebtMessageTime = styled.p`
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: bold;
  text-align: center;
  color: #707070;
`;

export const BottomMessage = styled.p`
  text-align: center;
  color: #707070;
`;

export const BottomMessageAccess = styled.p`
  margin-bottom: 1rem;
  text-align: center;
  color: #707070;
`;

export const InstructionMessage = styled.p`
  text-align: center;
  color: #112efc;
`;

export const CardItem = styled.div`
  margin: 0.5rem 1rem;
`;

export const AreaItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const AreaHeaderItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0rem 1rem 0rem 1rem;
`;

export const AreaItemLeft = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const AreaItemRigth = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;

`;

export const DescriptionHeaderTitleItem = styled.div`
  padding: 1rem;
  font-size: .88rem;
  font-weight: bold;
  color: #707070;

  @media(max-width: 770px) {
    padding: 0.5rem;
  }
`;

export const DescriptionTitleItem = styled.div`
  padding: 1rem;
  font-size: .88rem;
  font-weight: bold;
  color: #464eff;

  @media(max-width: 770px) {
    padding: 0.5rem;
  }
`;

export const DescriptionItem = styled.div`
  padding: 1rem;
  font-size: .88rem;
  font-weight: bold;
  color: #707070;

  @media(max-width: 770px) {
    padding: 0.5rem;
  }
`;

export const DescriptionItemTitle = styled.div`
  padding: 1rem;
  font-size: .88rem;
  font-weight: bold;
  color: #707070;
  margin-right: 2rem;

  @media(max-width: 770px) {
    padding: 0.5rem;
  }
`;

export const CardHeader = {
  backgroundColor: "rgb(230, 223, 223)",
  color: "rgb(112, 112, 112)",
  fontSize: ".9rem",
  fontWeight: "550",
  padding: ".2rem 1rem",
  borderRadius: "0.3rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};


export const SubTitle = styled.p`
  font-size: .95rem;
  color: ${() => grayColor};
  margin: 1rem 0.5rem 1.5rem 0rem;

  @media(min-width: 770px) {
    margin: .5rem 0.5rem .5rem 0rem;
  }
`;

export const CenterItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: center;
  margin: 0.5rem 0.5rem 0.5rem 0rem !important;

  @media (max-width: 700px) {
    text-align: center;
  }
  @media (max-width: 400px) {
    font-size: 0.75rem;
  }
  @media (max-width: 310px) {
    font-size: 0.65rem;
  }
`;

export const LimitText = styled.div`
  white-space: nowrap;         /* Impede quebra de linha */
  overflow: hidden;           /* Oculta texto extra */
  text-overflow: ellipsis;    /* Adiciona "..." quando o texto é cortado */
  max-width: 30rem;             /* Define a largura máxima da div */
`;

export const CardBody = styled.div`
  font-weight: 500;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  margin-bottom: 0.5rem;
  padding: 0rem 1rem;
  border-radius: 1rem;
`;
